export default __webpack_public_path__ + "static/media/autarq.85784e45.webm";